import styled from "styled-components";

export const CustomTable = styled.div`
  width: 100%;
  /* max-width: 1160px; */
  margin: 0 auto 32px;
`;
